import axios from 'axios';
import store from '@/store';

// Fonction pour traduire les messages serveur en français
function translateMessage(msg) {
  const translations = {
    'Unauthorized': 'Droits insuffisants',
    'Forbidden': 'Accès refusé',
    'Not Found': 'Ressource introuvable',
    'Internal Server Error': 'Erreur serveur interne',
    'Bad Request': 'Requête invalide',
  };

  // Si le message est une chaîne et existe dans les traductions
  if (typeof msg === 'string' && translations[msg]) {
    return translations[msg];
  }

  return msg;
}

// Intercepteur pour ajouter automatiquement le token à toutes les requêtes
axios.interceptors.request.use(
  (config) => {
    // Récupérer le token actuel du store
    const token = store.state.currentUser?.token;
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur de réponse pour gérer les erreurs et traduire les messages
axios.interceptors.response.use(
  (response) => {
    // Traduire le message dans la réponse si présent
    if (response.data?.msg) {
      response.data.msg = translateMessage(response.data.msg);
    }
    if (response.data?.message) {
      response.data.message = translateMessage(response.data.message);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
    }
    
    // Traduire les messages d'erreur
    if (error.response?.data?.msg) {
      error.response.data.msg = translateMessage(error.response.data.msg);
    }
    if (error.response?.data?.message) {
      error.response.data.message = translateMessage(error.response.data.message);
    }
    
    return Promise.reject(error);
  }
);

export default axios;
